import { Typography } from '@signozhq/ui/typography';
import get from 'api/browser/localstorage/get';
import { LOCALSTORAGE } from 'constants/localStorage';
import { THEME_MODE } from 'hooks/useDarkMode/constant';

import gitlabLogoUrl from '@/assets/Logos/gitlab-logo.svg';

import './AppLoading.styles.scss';

function AppLoading(): JSX.Element {
	// Get theme from localStorage directly to avoid context dependency
	const getThemeFromStorage = (): boolean => {
		try {
			const theme = get(LOCALSTORAGE.THEME);
			return theme !== THEME_MODE.LIGHT; // Return true for dark, false for light
		} catch (error) {
			// If localStorage is not available, default to dark theme
			return true;
		}
	};

	const isDarkMode = getThemeFromStorage();

	return (
		<div className={`app-loading-container ${isDarkMode ? 'dark' : 'lightMode'}`}>
			<div className="perilin-bg" />
			<div className="app-loading-content">
				<div className="loader" />

				<div className="brand">
					<img src={gitlabLogoUrl} alt="GitLab" className="brand-logo" />
					<Typography.Title level={2} className="brand-title">
						GitLab Observability
					</Typography.Title>
				</div>
			</div>
		</div>
	);
}

export default AppLoading;
